//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useStore } from '../../store/store';
import { useDispatch, useSelector } from 'react-redux';
import { processEmail } from 'src/store/profile/actions';
import { useNav } from '../../hooks/nav';
import { ReactComponent as BackIcon } from '../../assets/images/arrowLeft.svg';
import Analytics from '@web-solutions/module-analytics';
import { reInit as reInitRemoteConfig } from '@web-solutions/core/store/remote-config/actions';
import { t } from '@web-solutions/module-localization';
import Button from 'src/onboarding/components/ui/button/Button';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import { Email, domains } from '@smastrom/react-email-autocomplete';
import './style.scss';
import getLocale from 'src/localization/get-locale';
import { validateEmail } from 'src/onboarding/helpers/validateEmail';
import { useRemoteConfig } from '@web-solutions/base-app/hooks/use-remote-config';
import { createCustomer, initOrders } from 'core/store/billing/actions';
import { selectPaymentSystem } from 'core/store/billing/selectors';
import { setupStripePayment } from 'src/onboarding/helpers/setupStripePayment';
import { getLocalizedText } from 'core/utils/localized';

function Page() {
  const [localEmail, setLocalEmail] = useState('');
  const setEmail = useStore((state) => state.setEmail);

  const dispatch = useDispatch();
  const { onNext, onPrev, currentIndex } = useNav();
  const setPage = useStore((state) => state.setPage);
  const { email: emailRemote } = useRemoteConfig();
  const locale = getLocale();

  const [errorMessage, setErrorMessage] = useState('');
  const [isValid, setIsValid] = useState(false);
  const [keyboardOpen, setKeyboardOpen] = useState(false);

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const paymentSystem = useSelector(selectPaymentSystem);

  const baseList = [
    'gmail.com',
    'yahoo.com',
    'hotmail.com',
    'outlook.com',
    'icloud.com',
    'aol.com',
  ];

  const isIOS = () => {
    return (
      /iPad|iPhone|iPod/.test(navigator.userAgent) ||
      (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)
    );
  };

  useEffect(() => {
    const preventScroll = (e) => {
      const dropdown = document.querySelector('.custom-email-dropdown');
      if (!dropdown || !dropdown.contains(e.target)) {
        e.preventDefault();
      }
    };

    if (isDropdownOpen || keyboardOpen) {
      document.body.classList.add('no-scroll');
      document.body.addEventListener('touchmove', preventScroll, { passive: false });
    } else {
      document.body.classList.remove('no-scroll');
      document.body.removeEventListener('touchmove', preventScroll);
    }

    return () => {
      document.body.classList.remove('no-scroll');
      document.body.removeEventListener('touchmove', preventScroll);
    };
  }, [isDropdownOpen, keyboardOpen]);

  useEffect(() => {
    const preventScroll = (e) => {
      const dropdown = document.querySelector('.custom-email-dropdown');
      if (!dropdown || !dropdown.contains(e.target)) {
        e.preventDefault();
      }
    };

    if (isDropdownOpen || keyboardOpen) {
      document.body.classList.add('no-scroll');
      document.body.addEventListener('touchmove', preventScroll, { passive: false });
    } else {
      document.body.classList.remove('no-scroll');
      document.body.removeEventListener('touchmove', preventScroll);
    }

    return () => {
      document.body.classList.remove('no-scroll');
      document.body.removeEventListener('touchmove', preventScroll);
    };
  }, [isDropdownOpen, keyboardOpen]);

  useEffect(() => {
    const input = document.getElementById('email-field');
    if (!input || !isIOS()) return;

    let resizeTimeout: number | null = null;

    const updateButtonPosition = (keyboardHeight: number) => {
      const buttonElement = document.querySelector('.next-wrapper');
      const buttonBg = document.querySelector('.button-white-bg');

      const bottomValue = keyboardHeight > 100 ? `${keyboardHeight}px` : '0px';

      if (buttonElement) buttonElement.style.bottom = bottomValue;
      if (buttonBg) buttonBg.style.bottom = bottomValue;
    };

    const handleViewportResize = () => {
      if (!window.visualViewport) return;

      const keyboardHeight = window.innerHeight - window.visualViewport.height;
      const keyboardNowOpen = keyboardHeight > 150;

      setKeyboardOpen(keyboardNowOpen);
      updateButtonPosition(keyboardHeight);
    };

    const onFocus = () => {
      setKeyboardOpen(true);
      handleViewportResize();
      requestAnimationFrame(() => {
        setTimeout(() => handleViewportResize(), 200);
      });
    };

    const onBlur = () => {
      setKeyboardOpen(false);
      updateButtonPosition(0);
    };

    const onResize = () => {
      if (resizeTimeout) clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(handleViewportResize, 50);
    };

    input.addEventListener('focus', onFocus);
    input.addEventListener('blur', onBlur);
    window.visualViewport?.addEventListener('resize', onResize);

    return () => {
      input.removeEventListener('focus', onFocus);
      input.removeEventListener('blur', onBlur);
      window.visualViewport?.removeEventListener('resize', onResize);
      if (resizeTimeout) clearTimeout(resizeTimeout);
    };
  }, []);

  useEffect(() => {
    if (!localEmail) {
      setErrorMessage('');
      setIsValid(false);
    } else if (!validateEmail(localEmail)) {
      setErrorMessage(t('onboarding.email.errorMessage'));
      setIsValid(false);
    } else {
      setErrorMessage('');
      setIsValid(true);
    }
  }, [localEmail]);

  const handleSubmit = useCallback(
    async (value) => {
      // @ts-ignore
      window.fbq('track', 'CompleteRegistration');
      await dispatch(processEmail(value));
      await dispatch(reInitRemoteConfig());

      try {
        await setupStripePayment({ email: value, dispatch, paymentSystem });
      } catch (error) {
        console.error('[EmailPage] Error in handleSubmit:', error);
      }
    },
    [dispatch, paymentSystem]
  );

  const getPaddingLeft = (email: string | undefined, locale: string): number => {
    if (email?.length >= 1) return 0;

    switch (locale) {
      case 'en':
      case 'tr':
        return 130;
      // case 'it':
      // case 'cs': return 60;
      // case 'de':
      // case 'id':
      // case 'fr':
      // case 'pt': return 45;
      // case 'es':  return 40;
      default:
        return 70;
    }
  };

  return (
    <div className='page'>
      {currentIndex !== 0 && (
        <div className={'back'} onClick={onPrev}>
          <BackIcon />
        </div>
      )}
      <div className='wrapper-info'>
        <Title tag='h2'>{getLocalizedText(emailRemote.title, locale)}</Title>
        <Text size='m' medium className='description'>
          {getLocalizedText(emailRemote.subTitle, locale)}
        </Text>
      </div>

      <div className='controls email' style={{ paddingBottom: '100px' }}>
        <Email
          id='email-field'
          value={localEmail}
          onChange={setLocalEmail}
          placeholder={t('onboarding.email.placeholder')}
          autoFocus
          baseList={baseList}
          refineList={domains}
          classNames={{
            wrapper: 'custom-email-wrapper',
            dropdown: `custom-email-dropdown ${keyboardOpen ? 'keyboard-open' : ''}`,
            input: 'custom-email-input',
            suggestion: 'custom-email-suggestion',
            domain: 'custom-email-domain',
          }}
          style={{
            textAlign: (localEmail?.length || 0) >= 1 ? 'center' : 'left',
            caretColor: 'black',
            paddingLeft: getPaddingLeft(localEmail, locale),
          }}
        />
        <Caption size='m' className='error-message' style={{ margin: 0 }}>
          {errorMessage}
        </Caption>
        <span className='info'>
          <span className='top-info'>{t('onboarding.email.topInfo')}</span>
          <span className='bottom-info'>
            <a onClick={() => setPage('privacy-policy')}>{t('onboarding.email.privacyPolicy')}</a>{' '}
            <span className='bottom-info-devider'>&</span>{' '}
            <a onClick={() => setPage('terms-of-use')}>{t('onboarding.email.TermofUse')}</a>
          </span>
        </span>
      </div>
      <div className={`button-white-bg ${keyboardOpen && isIOS() ? 'keyboard-open' : ''}`}></div>
      <div className={`next-wrapper ${keyboardOpen && isIOS() ? 'keyboard-open' : ''}`}>
        <Button
          className={!isValid ? 'disabled' : ''}
          title={t('onboarding.email.continue')}
          onClick={async () => {
            if (!isValid) return;
            setEmail(localEmail);
            await handleSubmit(localEmail);
            Analytics.trackEvent(`step${currentIndex + 1}`, 'complete', {
              page: 'email',
              answer: localEmail,
            });

            gtag('event', 'conversion', {
              send_to: 'AW-17149973324/cDa6CIPlt_0aEMym3_E_',
              value: 1.0,
              currency: 'USD',
            });

            onNext();
          }}
        />
      </div>
    </div>
  );
}

export default Page;
